import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-slides-icon]',
  template: `
    <svg:path
      d="M13.333 2.66602H2.66602V9.33203C2.66602 9.50877 2.73641 9.6787 2.86133 9.80371C2.98635 9.92874 3.1562 9.99902 3.33301 9.99902H12.666C12.8428 9.99902 13.0127 9.92874 13.1377 9.80371C13.2627 9.67869 13.333 9.50884 13.333 9.33203V2.66602ZM14.666 9.33203C14.666 9.86246 14.4552 10.371 14.0801 10.7461C13.705 11.1212 13.1964 11.332 12.666 11.332H9.6084L11.8047 13.5273C12.065 13.7877 12.065 14.2104 11.8047 14.4707C11.5443 14.7311 11.1217 14.7311 10.8613 14.4707L7.99902 11.6074L5.1377 14.4707C4.87744 14.7308 4.45563 14.7307 4.19531 14.4707C3.93496 14.2104 3.93496 13.7877 4.19531 13.5273L6.39062 11.332H3.33301C2.80257 11.332 2.29402 11.1212 1.91895 10.7461C1.54397 10.371 1.33301 9.86239 1.33301 9.33203V2.66602C0.964818 2.66602 0.666016 2.36721 0.666016 1.99902C0.666016 1.63083 0.964818 1.33203 1.33301 1.33203H14.666C15.0342 1.33203 15.333 1.63083 15.333 1.99902C15.333 2.36721 15.0342 2.66602 14.666 2.66602V9.33203Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlidesIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
